export default __webpack_public_path__ + "static/media/Modelo 9.24294a31.png";